import { UpdateProjectFileRequest } from "@/api";

export const enum EditorWorkerMessageType {
  SAVE = "editor-save-worker-message",
}

interface WorkerMessageBase {
  impersonationHeaders?: Record<string, string>;
}

export interface EditorSaveWorkerMessage extends WorkerMessageBase {
  type: EditorWorkerMessageType.SAVE;
  payload: Omit<UpdateProjectFileRequest, "body"> & { body: string };
  basePath: string;
  compress: boolean;
}

export type WorkerMessage = EditorSaveWorkerMessage;
